module.exports = __webpack_public_path__ + "media/images/premium/premium_image-cac40ec2ba3ea5b553f048d3b643d0e4.png";